<div class="autocomplete-container">
  <div class="autocomplete-input-wrapper" [class.has-clear]="showClearButton">
    <input
      type="text"
      class="autocomplete-input"
      [ngModel]="inputValue"
      (ngModelChange)="onInputChange($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [placeholder]="placeholder"
      [disabled]="disabled"
      autocomplete="off"
    />
    <button
      type="button"
      class="clear-button"
      *ngIf="showClearButton"
      (mousedown)="onClear($event)"
      aria-label="Clear selection"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M15 5L5 15M5 5L15 15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <svg
      class="chevron-icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [class.rotated]="isOpen"
      aria-hidden="true"
    >
      <path
        d="M5.28 7.38L10 12.1L14.72 7.38"
        stroke="#15172E"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="autocomplete-menu" *ngIf="isOpen && !disabled" (mousedown)="$event.preventDefault()">
    <div class="autocomplete-options">
      <div
        class="option-item"
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        (mousedown)="selectOption(option.value)"
      >
        <span class="option-label">{{ option.label }}</span>
      </div>
      <div class="no-results" *ngIf="filteredOptions.length === 0">No results found</div>
    </div>
  </div>
</div>
